import type { ClientAccuracy } from '../types';

/**
 * The accuracy badge in COUNTS, not adjectives (Christian, 2026-11-02; ptc-docs plan 2026-11-02 §2): "Dependable · 7 exact
 * in a row", or "4 of 6 exact in a row". The rule stays the server's: `dependable` arrives for an admin only, and this never
 * rebuilds it from the streak.
 */
export function badgeWords(row: Pick<ClientAccuracy, 'streak' | 'dependable'>, dependableAfter: number): {
  key: 'accuracyPage.badge.dependable' | 'accuracyPage.badge.count';
  params: { count: number; n: number };
} {
  return row.dependable
    ? { key: 'accuracyPage.badge.dependable', params: { count: row.streak, n: dependableAfter } }
    : { key: 'accuracyPage.badge.count', params: { count: row.streak, n: dependableAfter } };
}
